module.exports = "/images/move-in.png?92d8a2bcdecc803c3ccfdab51f1fc1ad";